import { motion } from 'framer-motion';
import { H2, H3, Body, BodyLarge } from '../ui/Typography';
import { investorFeatures } from '../../data/investorResources';

export default function InvestorResources() {
  return (
    <div className="bg-white rounded-xl shadow-lg p-8">
      <div className="text-center mb-12">
        <H2 className="text-primary mb-4">Investor Resources Hub</H2>
        <div className="inline-block px-4 py-2 bg-secondary/10 rounded-full text-secondary font-semibold mb-4">
          Coming Soon
        </div>
        <BodyLarge className="text-gray-600">
          Comprehensive tools and insights for informed investment decisions
        </BodyLarge>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {investorFeatures.map((feature, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
          >
            <div className="bg-gray-50 rounded-lg p-6 hover:bg-gray-100 transition-colors h-full">
              <div className="flex items-center mb-4">
                <feature.icon className="w-8 h-8 text-secondary" />
              </div>
              <H3 className="text-gray-900 mb-4">{feature.title}</H3>
              <Body className="text-gray-600">{feature.description}</Body>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
}